// @ts-expect-error no types for ui-addon-iframeable
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import ErrorBoundary from 'customer-data-objects-ui-components/ErrorBoundary';
import { URL_LOAD_LOCATION, getPaymentsEnrollmentEmbedUrl } from '../../constants/urls';
import useCanOpenPaymentsEnrollment from '../../hooks/useCanOpenPaymentsEnrollment';
import { CancelSurvey } from '../../types';
import CancelModal from '../modals/CancelModal';
import NativeCancelSurvey from '../modals/NativeCancelSurvey';
import ProcessorPickerCancelSurvey from '../modals/ProcessorPickerCancelSurvey';
import StripeApplicationFallbackModal from '../modals/StripeApplicationFallbackModal';
import { getLocationFromIframeId } from '../../utils/location';
import StripeApplicationSuccessModal from '../modals/StripeApplicationSuccessModal';
import OauthAccountOnboardingModal from '../modals/OauthAccountOnboardingModal';
import { useIsUngatedForOptimizePostEnrollM2M3, useIsUngatedForPreApproval } from 'growth-payments-core/auth/gates';
import PreApprovedApplicationSuccessModal from '../modals/PreApprovedApplicationSuccessModal';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import { usePaymentsEnrollmentUtilitiesContext } from '../../context/PaymentsEnrollmentUtilitiesContext';
import ApplicationSuccessModalV2 from '../modals/ApplicationSuccessModalV2';
import PreApprovedApplicationSuccessModalV2 from '../modals/PreApprovedApplicationSuccessModalV2';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getCancelSurveyComponent = cancelSurvey => {
  switch (cancelSurvey) {
    case CancelSurvey.NATIVE:
      return NativeCancelSurvey;
    case CancelSurvey.PROCESSOR_PICKER:
    case CancelSurvey.SELECT:
      return ProcessorPickerCancelSurvey;
    default:
      return () => null;
  }
};
const PaymentsEnrollmentEmbedBase = ({
  shouldReloadOnEnrollmentComplete = true,
  enrollmentFlowLocation
}) => {
  const {
    loading: loadingConnectedAccounts,
    canOpenPaymentsEnrollment
  } = useCanOpenPaymentsEnrollment();
  const isUngatedForPreApproval = useIsUngatedForPreApproval();
  const isUngatedForOptimizePostEnrollM2M3 = useIsUngatedForOptimizePostEnrollM2M3();
  const {
    currentEnrollmentFlow,
    handleIframeReady,
    handleIframeOnMessage,
    isLoading,
    handlePaymentsEnrollmentClose: onClose,
    showNativeSuccessModal,
    setShowNativeSuccessModal,
    setShowNativeFallbackModal,
    showEmbeddedOnboarding,
    setShowEmbeddedOnboarding,
    showNativeFallbackModal,
    showCancelModal,
    showOAuthOnboardingSuccessModal,
    setShowOAuthOnboardingSuccessModal,
    handleCloseCancelModal,
    cancelSurveyType,
    setCancelSurveyType,
    businessTypeDetails,
    sourceApp,
    location
  } = usePaymentsEnrollmentUtilitiesContext();
  if (showNativeSuccessModal) {
    if (isUngatedForPreApproval) {
      return isUngatedForOptimizePostEnrollM2M3 ? /*#__PURE__*/_jsx(PreApprovedApplicationSuccessModalV2, {
        shouldReloadOnEnrollmentComplete: shouldReloadOnEnrollmentComplete,
        onClose: () => setShowNativeSuccessModal(false)
      }) : /*#__PURE__*/_jsx(PreApprovedApplicationSuccessModal, {
        businessTypeDetails: businessTypeDetails,
        shouldReloadOnEnrollmentComplete: shouldReloadOnEnrollmentComplete,
        onClose: () => setShowNativeSuccessModal(false)
      });
    } else {
      return isUngatedForOptimizePostEnrollM2M3 ? /*#__PURE__*/_jsx(ApplicationSuccessModalV2, {
        shouldReloadOnEnrollmentComplete: shouldReloadOnEnrollmentComplete,
        onClose: () => setShowNativeSuccessModal(false)
      }) : /*#__PURE__*/_jsx(StripeApplicationSuccessModal, {
        businessTypeDetails: businessTypeDetails,
        shouldReloadOnEnrollmentComplete: shouldReloadOnEnrollmentComplete,
        onClose: () => setShowNativeSuccessModal(false)
      });
    }
  }
  if (showNativeFallbackModal) {
    return /*#__PURE__*/_jsx(StripeApplicationFallbackModal, {
      businessTypeDetails: businessTypeDetails,
      onClose: () => {
        setShowNativeFallbackModal(false);
        setShowEmbeddedOnboarding(true);
      }
    });
  }
  const CancelSurveyModal = getCancelSurveyComponent(cancelSurveyType);
  const shouldOpenPaymentsEnrollment = (!!currentEnrollmentFlow || showEmbeddedOnboarding) && (enrollmentFlowLocation === location || enrollmentFlowLocation === URL_LOAD_LOCATION);

  // Handles case where enrollment flow is loaded directly from the URL by
  // only rendering the iframe for the first rendered component and avoiding
  // multiple iframes from being rendered.
  const alreadyRenderedEnrollmentPanel = document.querySelector('[id^="payments-enrollment-embed-iframe"]');
  const isCurrentLocation = alreadyRenderedEnrollmentPanel ? getLocationFromIframeId(alreadyRenderedEnrollmentPanel.id) === location : true;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFloatingAlertList, {}), showCancelModal && /*#__PURE__*/_jsx(CancelModal, {
      onConfirm: () => {
        onClose();
        handleCloseCancelModal(CancelSurvey.NATIVE);
      },
      onGoBack: handleCloseCancelModal
    }), cancelSurveyType !== CancelSurvey.NONE && /*#__PURE__*/_jsx(CancelSurveyModal, {
      closeModal: () => setCancelSurveyType(CancelSurvey.NONE)
    }), showOAuthOnboardingSuccessModal && /*#__PURE__*/_jsx(ErrorBoundary, {
      boundaryName: "OauthAccountOnboardingModal",
      showRefreshAlert: true,
      onComponentDidCatch: () => {
        setShowOAuthOnboardingSuccessModal(false);
      },
      children: /*#__PURE__*/_jsx(OauthAccountOnboardingModal, {
        onClose: () => setShowOAuthOnboardingSuccessModal(false)
      })
    }), /*#__PURE__*/_jsx(UIModalIFrame, {
      appName: "payments-enrollment-embed",
      name: "fullscreen-panel",
      use: "fullscreen",
      onMessage: handleIframeOnMessage,
      show: shouldOpenPaymentsEnrollment && isCurrentLocation && !loadingConnectedAccounts && canOpenPaymentsEnrollment,
      onReady: handleIframeReady,
      showLoadingIndicator: isLoading,
      src: getPaymentsEnrollmentEmbedUrl(),
      iframePassthruProps: {
        id: `payments-enrollment-embed-iframe-${location}`,
        'data-test-id': `payments-enrollment-embed-iframe-${location}`
      },
      embeddedPassthruProps: {
        source: sourceApp,
        showEmbeddedOnboarding
      },
      onClose: onClose
    })]
  });
};
export default PaymentsEnrollmentEmbedBase;